// client/src/utils/validateSkillLevel.js

import { SKILL_LEVELS } from '../constants/skillLevels'

/**
 * Validates if a skill level value is valid
 * @param {*} skillLevel - The skill level value to validate
 * @returns {boolean} True if valid, false otherwise
 */
export function isValidSkillLevel(skillLevel) {
  if (skillLevel === null || skillLevel === undefined) {
    return false
  }

  if (typeof skillLevel !== 'number' || isNaN(skillLevel)) {
    return false
  }

  return SKILL_LEVELS.some((level) => level.value === skillLevel)
}
